module.exports = __webpack_public_path__ + "img/meth-bag.16cb2edd.jpg";